import { useState } from 'react';
import ImageUploading from 'react-images-uploading';

const Passport = () => {
  const [schoolName, setSchoolName] = useState('');
  const [images, setImages] = useState([]);

  const [form, setForm] = useState([
    {
      name: '',
      class: '',
      file: '',
    },
    {
      name: '',
      class: '',
      file: '',
    },
  ]);

  const onChange = (imageList, addUpdateIndex) => {
    // data for submit
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
  };

  const setFormFunc = (e, index) => {
    const vals = form.map((el, i) => {
      if (i === index) {
        return {
          ...el,
          [e.target.name]:
            e.target.name === 'file' ? e.target.files[0] : e.target.value,
        };
      } else {
        return el;
      }
    });
    setForm(vals);
  };

  const addMore = () => {
    setForm((prev) => [...prev, { name: '', class: '', file: '' }]);
  };

  const deleteFunc = (index) => {
    const val = form.filter((e, i) => i !== index);
    setForm(val);
  };
  return (
    <div className="container mx-auto px-5">
      <h1 className="mt-2 mb-4 text-md md:text-3xl font-semibold title-color">
        NATIONAL DIGITAL LITERACY COMPETITION 2022
        <br />
        <br />
        <span className="text-blue-500">FINALIST PASSPORT UPLOAD</span>
      </h1>
      <input
        type="text"
        name="schoolName"
        value={schoolName}
        onChange={(e) => {
          setSchoolName(e.target.value);
        }}
        className="bg-stone-50 rounded-lg p-3 w-full mb-5"
        placeholder="Name of School"
      />
      <h1 className="text-3xl my-4">Student Passport</h1>
      <div className="flex flex-col gap-3 justify-center">
        {form.map((val, index) => (
          <label key={index} className="grid grid-cols-2 gap-4">
            <input
              type="text"
              name="name"
              value={val.name}
              placeholder="name"
              className="bg-stone-50 rounded-lg p-3 mb-5"
              onChange={(e) => {
                setFormFunc(e, index);
              }}
            />
            <input
              type="text"
              className="bg-stone-50 rounded-lg p-3 mb-5"
              placeholder="class"
              name="class"
              value={val.class}
              onChange={(e) => {
                setFormFunc(e, index);
              }}
            />
            <input
              type="file"
              className="bg-stone-50 rounded-lg p-3 mb-5"
              placeholder="class"
              name="file"
              onChange={(e) => {
                setFormFunc(e, index);
              }}
            />
            <button
              className="text-red-500 border my-auto p-3 rounded-md w-2/4"
              onClick={() => deleteFunc(index)}
            >
              delete
            </button>
          </label>
        ))}
      </div>
      <button className="px-3 py-2 bg-cyan-200 rounded-sm" onClick={addMore}>
        Add more
      </button>
      <br />
      <br />
      <br />
      <ImageUploading
        multiple
        value={images}
        onChange={onChange}
        maxNumber={1}
        dataURLKey="data_url"
      >
        {({
          imageList,
          onImageUpload,
          onImageRemoveAll,
          onImageUpdate,
          onImageRemove,
          isDragging,
          dragProps,
        }) => (
          // write your building UI
          <div className="upload__image-wrapper">
            <button
              style={isDragging ? { color: 'red' } : undefined}
              onClick={onImageUpload}
              {...dragProps}
            >
              Click or Drop here
            </button>
            &nbsp;
            <button onClick={onImageRemoveAll}>Remove all images</button>
            {imageList.map((image, index) => (
              <div key={index} className="image-item">
                <img src={image['data_url']} alt="" width="100" />
                <div className="image-item__btn-wrapper">
                  <button onClick={() => onImageUpdate(index)}>Update</button>
                  <button onClick={() => onImageRemove(index)}>Remove</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </ImageUploading>
    </div>
  );
};

export default Passport;
